import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {CoreSidebarService} from '../../../@core/components/core-sidebar/core-sidebar.service';
import {SupportService} from '../../shared/services/support.service';
import {FileService} from '../../shared/services/file.service';
import {AlertService} from '../../shared/services/alert.service';
import {AppConstants} from '../../shared/constants/app-constant';

@Component({
    selector: 'app-support-tickets',
    templateUrl: './support-tickets.component.html',
    styleUrls: ['./support-tickets.component.scss']
})
export class SupportTicketsComponent implements OnInit {
    showSearch = false;
    searchForm: FormGroup;
    filterForm: FormGroup;
    updateStatusForm: FormGroup;
    submitting: any = false;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    data: any;
    supportData: any = [];
    imageBaseUrl: any = AppConstants.BUCKET_URL;

    constructor(private fb: FormBuilder,
                public modalService: NgbModal,
                private router: Router,
                private _coreSidebarService: CoreSidebarService,
                private supportService: SupportService,
                private fileService: FileService,
                private alertService: AlertService) {
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'username': [''],
            'ticket_no': [''],
            'ticket_status': ['']
        });
        this.updateStatusForm = this.fb.group({
            'status': ['']
        });
        this.get();
    }

    search() {
        const params = {
            'type': (this.searchForm.value && this.searchForm.value.type) ? this.searchForm.value.type : '',
            'subject': (this.searchForm.value && this.searchForm.value.subject) ? this.searchForm.value.subject : '',
            'status': (this.searchForm.value && this.searchForm.value.status) ? this.searchForm.value.status : ''
        };
    }

    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            'type': (this.searchForm.value && this.searchForm.value.type) ? this.searchForm.value.type : '',
            'subject': (this.searchForm.value && this.searchForm.value.subject) ? this.searchForm.value.subject : '',
            'status': (this.searchForm.value && this.searchForm.value.status) ? this.searchForm.value.status : ''
        };
    }

    openStatusModal(content) {
        this.modalService.open(content, {'size': 'sm'});
    }

    toggleSidebar(): void {
        this._coreSidebarService.getSidebarRegistry('add-ticket').toggleOpen();
    }

    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        params.added_type = 'USER';
        this.supportService.get(params).subscribe(data => {
            if (data && data['data'] && data['data'].length > 0) {
                this.supportData = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            }
        });
    }

    add(): void {
        this.data = undefined;
        this.toggleSidebar();
    }

    getData(valueSubmit: any): void {
        if (valueSubmit) {
            this.toggleSidebar();
        }
    }

    edit(data) {
        this.data = data;
        this.toggleSidebar();
    }

    openExternalUrl(url) {
        window.open(url, '_blank');
    }
}
